/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Freebies_Headings_PastInputs */

const id_freebies_headings_past = /** @type {(inputs: Freebies_Headings_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game Gratis Sebelumnya`)
};

const ms_freebies_headings_past = /** @type {(inputs: Freebies_Headings_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permainan Percuma Lepas`)
};

const da_freebies_headings_past = /** @type {(inputs: Freebies_Headings_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidligere Gratis Spil`)
};

const de_freebies_headings_past = /** @type {(inputs: Freebies_Headings_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergangene kostenlose Spiele`)
};

const en_us2_freebies_headings_past = /** @type {(inputs: Freebies_Headings_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Past Free Games`)
};

const es_es2_freebies_headings_past = /** @type {(inputs: Freebies_Headings_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juegos gratis pasados`)
};

const es_mx2_freebies_headings_past = /** @type {(inputs: Freebies_Headings_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juegos gratis anteriores`)
};

const fil_freebies_headings_past = /** @type {(inputs: Freebies_Headings_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Nakaraang Libreng Laro`)
};

const fr_freebies_headings_past = /** @type {(inputs: Freebies_Headings_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anciens jeux gratuits`)
};

const it_freebies_headings_past = /** @type {(inputs: Freebies_Headings_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giochi gratuiti passati`)
};

const hu_freebies_headings_past = /** @type {(inputs: Freebies_Headings_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korábbi ingyenes játékok`)
};

const nl_freebies_headings_past = /** @type {(inputs: Freebies_Headings_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eerdere gratis games`)
};

const no_freebies_headings_past = /** @type {(inputs: Freebies_Headings_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidligere gratis spill`)
};

const pl_freebies_headings_past = /** @type {(inputs: Freebies_Headings_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poprzednie darmowe gry`)
};

const pt_br2_freebies_headings_past = /** @type {(inputs: Freebies_Headings_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogos grátis anteriores`)
};

const pt_freebies_headings_past = /** @type {(inputs: Freebies_Headings_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogos grátis anteriores`)
};

const ro_freebies_headings_past = /** @type {(inputs: Freebies_Headings_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jocuri gratuite anterioare`)
};

const fi_freebies_headings_past = /** @type {(inputs: Freebies_Headings_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aikaisemmat ilmaispelit`)
};

const sv_freebies_headings_past = /** @type {(inputs: Freebies_Headings_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidigare gratis spel`)
};

const vi_freebies_headings_past = /** @type {(inputs: Freebies_Headings_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game miễn phí trước đây`)
};

const tr_freebies_headings_past = /** @type {(inputs: Freebies_Headings_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geçmiş Ücretsiz Oyunlar`)
};

const cs_freebies_headings_past = /** @type {(inputs: Freebies_Headings_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dřívější hry zdarma`)
};

const bg_freebies_headings_past = /** @type {(inputs: Freebies_Headings_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предишни безплатни игри`)
};

const ru_freebies_headings_past = /** @type {(inputs: Freebies_Headings_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бесплатные игры в прошлом`)
};

const uk_freebies_headings_past = /** @type {(inputs: Freebies_Headings_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Минулі безкоштовні ігри`)
};

const ar_freebies_headings_past = /** @type {(inputs: Freebies_Headings_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الألعاب المجانية السابقة`)
};

const hi_freebies_headings_past = /** @type {(inputs: Freebies_Headings_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिछले मुफ़्त गेम`)
};

const th_freebies_headings_past = /** @type {(inputs: Freebies_Headings_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกมฟรีในอดีต`)
};

const ja_freebies_headings_past = /** @type {(inputs: Freebies_Headings_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`過去の無料ゲーム`)
};

const zh_cn2_freebies_headings_past = /** @type {(inputs: Freebies_Headings_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`往期免费游戏`)
};

const zh_hant1_freebies_headings_past = /** @type {(inputs: Freebies_Headings_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`往期免費遊戲`)
};

const ko_freebies_headings_past = /** @type {(inputs: Freebies_Headings_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지난 무료 게임`)
};

/**
* | output |
* | --- |
* | "Past Free Games" |
*
* @param {Freebies_Headings_PastInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const freebies_headings_past = /** @type {((inputs?: Freebies_Headings_PastInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Freebies_Headings_PastInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_freebies_headings_past(inputs)
	if (locale === "ms") return ms_freebies_headings_past(inputs)
	if (locale === "da") return da_freebies_headings_past(inputs)
	if (locale === "de") return de_freebies_headings_past(inputs)
	if (locale === "en-US") return en_us2_freebies_headings_past(inputs)
	if (locale === "es-ES") return es_es2_freebies_headings_past(inputs)
	if (locale === "es-MX") return es_mx2_freebies_headings_past(inputs)
	if (locale === "fil") return fil_freebies_headings_past(inputs)
	if (locale === "fr") return fr_freebies_headings_past(inputs)
	if (locale === "it") return it_freebies_headings_past(inputs)
	if (locale === "hu") return hu_freebies_headings_past(inputs)
	if (locale === "nl") return nl_freebies_headings_past(inputs)
	if (locale === "no") return no_freebies_headings_past(inputs)
	if (locale === "pl") return pl_freebies_headings_past(inputs)
	if (locale === "pt-BR") return pt_br2_freebies_headings_past(inputs)
	if (locale === "pt") return pt_freebies_headings_past(inputs)
	if (locale === "ro") return ro_freebies_headings_past(inputs)
	if (locale === "fi") return fi_freebies_headings_past(inputs)
	if (locale === "sv") return sv_freebies_headings_past(inputs)
	if (locale === "vi") return vi_freebies_headings_past(inputs)
	if (locale === "tr") return tr_freebies_headings_past(inputs)
	if (locale === "cs") return cs_freebies_headings_past(inputs)
	if (locale === "bg") return bg_freebies_headings_past(inputs)
	if (locale === "ru") return ru_freebies_headings_past(inputs)
	if (locale === "uk") return uk_freebies_headings_past(inputs)
	if (locale === "ar") return ar_freebies_headings_past(inputs)
	if (locale === "hi") return hi_freebies_headings_past(inputs)
	if (locale === "th") return th_freebies_headings_past(inputs)
	if (locale === "ja") return ja_freebies_headings_past(inputs)
	if (locale === "zh-CN") return zh_cn2_freebies_headings_past(inputs)
	if (locale === "zh-Hant") return zh_hant1_freebies_headings_past(inputs)
	return ko_freebies_headings_past(inputs)
});
export { freebies_headings_past as "freebies.headings.past" }